import { customFetch } from 'utils/http';
import { UnexpectedError } from 'utils/errors';
import { getM8UserURL } from 'services/production/utils/getM8URL';

export const createDemoStackClaim = async (): Promise<string> => {
  const fetchURL = getM8UserURL('createDeomStackClaim');

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new UnexpectedError();
  }

  const { url } = await response.json();

  return url;
};
